import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_QUESTION_DETAIL = 'GET_QUESTION_DETAIL';
export const GET_QUESTION_DETAIL_SUCCESS = 'GET_QUESTION_DETAIL_SUCCESS';
export const GET_QUESTION_DETAIL_FAILURE = 'GET_QUESTION_DETAIL_FAILURE';

// Action Creators
export const getQuestionDetail = () => ({
  type: GET_QUESTION_DETAIL,
});

export const getQuestionDetailSuccess = (users) => ({
  type: GET_QUESTION_DETAIL_SUCCESS,
  payload: users,
});

export const getQuestionDetailFailure = (error) => ({
  type: GET_QUESTION_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getQuestionDetailData = (external, id) => {
  return async (dispatch) => {
    dispatch(getQuestionDetail());
    try {
      const response = await getMethodWithToken(
        url?.getQuestionDetail + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getQuestionDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getQuestionDetailFailure(error?.message));
    }
  };
};
